module.exports = __webpack_public_path__ + "static/027.thumb-227d47e2ec1f89a0e9019ed84275944a.jpg";